import { Component } from '@angular/core';
import { ListRendererWidgetBase } from '@capturum/builders/list-renderer';

@Component({
    selector: 'app-installer-overall-rating-widget',
    templateUrl: './installer-overall-rating-widget.component.html',
    styleUrls: ['./installer-overall-rating-widget.component.scss'],
    standalone: false
})
export class InstallerOverallRatingWidgetComponent extends ListRendererWidgetBase {}
